import styled from "styled-components";

export default styled.div`
  .cross-button {
    background-color: rgba(218, 218, 218, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    cursor: pointer;
    padding: 0.5rem;
  }
`;
